<template>
  <div class="adverts-group">
    <search-advert-piano
      @add="addPiano"
      @onSubmit="onSubmit"
      @resetSearch="resetSearch"
      :search="search"
      :stateList="stateList"
    />
    <add-adverts-piano
      ref="addAdvertPiano"
      :showPianoDialog="showPianoDialog"
      @cancel="cancel"
      @submit="currentChange"
    />
    <div class="vue-padding radius">
      <el-table
        v-loading="loading"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        :data="advertGroupList"
        style="width: 100%"
        max-height="638"
        :border="true"
      >
        <el-table-column
          prop="name"
          :show-overflow-tooltip="true"
          :label="$t('cAdvertPiano.name')"
          :align="'center'"
        ></el-table-column>
        <el-table-column prop="state" :label="$t('cAdvertPiano.status')" :align="'center'">
          <template slot-scope="scope">
            <div :class="[`state_${scope.row.state}`]">
              {{ getStateLabel(scope.row.state) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('cAdvertPiano.creatDate')" :align="'center'"></el-table-column>
        <el-table-column
          prop="startDate"
          :label="$t('cAdvertPiano.promozioneDate')"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          fixed="right"
          :label="$t('common.operate')"
          :width="$i18n.locale == 'zh_CN' ? 240 : 290"
          :align="'center'"
        >
          <template slot-scope="scope">
            <el-button size="mini" @click="editDetail(scope.row)" type="text" style="color: #183aff">{{
              $t("common.looking")
            }}</el-button>
            <el-button
              size="mini"
              @click="deleteAdvertPiano(scope.row.id)"
              type="text"
              style="color: #fd3333"
              v-hasPerm="['advert:piano:delete']"
            >
              {{ $t("common.delete") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        :page-size="page.pageSize"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  import searchAdvertPiano from "_c/adverts/SearchAdvertPiano";
  import addAdvertsPiano from "_c/adverts/AddAdvertsPiano";
  export default {
    name: "AdvertsPiano",
    components: {
      searchAdvertPiano,
      addAdvertsPiano
    },
    data() {
      return {
        search: {
          name: ""
        },
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        showPianoDialog: false,
        loading: false,
        advertGroupList: [],
        advertGroup: {
          id: "",
          name: "",
          notes: "",
          display: "",
          equipmentNo: "",
          adName: ""
        },
        showPianoDialogRela: false,
        showType: [],
        stateList: []
      };
    },
    mounted() {
      this.currentChange();
      this.listShowType();
      this.getStates();
    },
    methods: {
      getStates() {
        this.$api.dict("advertising_program_state").then(res => {
          if (res.code === 0) {
            this.stateList = res.data;
          }
        });
      },
      getStateLabel(value) {
        let item = this.stateList.find(item => item.value == value);
        return item ? item.label : "";
      },
      listShowType() {
        this.$api.dict("gp_show_type").then(res => {
          if (res.code === 0) {
            this.showType = res.data;
          }
        });
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.currentChange();
      },
      currentChange(pageIndex) {
        this.loading = true;
        this.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge(this.search, this.page);
        this.$api
          .request(this.$url.AdvertsPiano.page, this.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              this.advertGroupList = res.data.records;
              this.page.totalSize = parseInt(res.data.total);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      addPiano() {
        console.log(123);
        this.showPianoDialog = true;
      },
      resetSearch(data) {
        this.search = data;
        this.currentChange();
      },
      onSubmit(data) {
        this.search = data;
        this.currentChange();
      },
      cancel(dialog, state) {
        this.showPianoDialog = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },
      editAdvertGroup(row) {
        this.showPianoDialog = true;
        Object.keys(this.advertGroup).forEach(key => {
          this.advertGroup[key] = row[key];
        });
        this.advertGroup.id = row.id;
      },
      advertConfig(row) {
        this.showPianoDialogRela = true;
        Object.keys(this.advertGroup).forEach(key => {
          this.advertGroup[key] = row[key];
        });
        this.advertGroup.id = row.id;
      },
      deleteAdvertGroup(row) {
        this.$confirm(this.$t("advertGroup.delete"), this.$t("common.warning"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api
            .request(this.$url.AdvertGroup.delete, this.$method.delete, {
              id: row.id
            })
            .then(res => {
              if (res.code === 0) {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: res.msg,
                  type: "success"
                });
                this.currentChange(this.page.pageIndex);
              }
            });
        });
      },
      cancelAdvertGroupRela(dialog) {
        this.showPianoDialogRela = dialog;
      },
      editAdvertStatus(row) {
        this.loading = true;
        this.$api
          .request(
            row.planStatus == 1 ? this.$url.AdvertsPiano.pause : this.$url.AdvertsPiano.enable,
            this.$method.put,
            { id: row.id }
          )
          .then(res => {
            if (res.code === 0) {
              this.currentChange(this.page.pageIndex);
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },
      deleteAdvertPiano(id) {
        this.$confirm(this.$t("cAdvertPiano.deleteTip"), this.$t("common.warning"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api
            .request(this.$url.AdvertsPiano.delete, this.$method.delete, {
              id: id
            })
            .then(res => {
              if (res.code === 0) {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: res.msg,
                  type: "success"
                });
                this.currentChange(this.page.pageIndex);
              }
            });
        });
      },
      editDetail(row) {
        this.showPianoDialog = true;
        this.$refs.addAdvertPiano.beforeOpen(row);
      }
    }
  };
</script>

<style>
  .el-dialog__header {
    padding: 20px;
  }
  .el-dialog__body {
    padding: 0 20px;
    height: auto !important;
  }
  .el-dialog__footer {
    padding: 20px;
  }
  .state_1 {
    color: #13be27;
  }
  .state_2 {
    color: #fd3333;
  }
  .state_0 {
    color: #909399;
  }
</style>
